module.exports = __webpack_public_path__ + "static/media/img_2.63f0c0af.png";